import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SceneSection } from '../components/SceneSection';
import { ProblemSection } from '../components/ProblemSection';
import { OldSolutionsSection } from '../components/OldSolutionsSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { AudienceSection } from '../components/AudienceSection';
import { PromiseSection } from '../components/PromiseSection';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-amber-100 selection:text-amber-900" data-id="element-225">
      <HeroSection data-id="element-226" />
      <SceneSection data-id="element-227" />
      <ProblemSection data-id="element-228" />
      <OldSolutionsSection data-id="element-229" />
      <SolutionSection data-id="element-230" />
      <IncludesSection data-id="element-231" />
      <AudienceSection data-id="element-232" />
      <PromiseSection data-id="element-233" />
      <CTASection data-id="element-234" />
      <FAQSection data-id="element-235" />
      <Footer data-id="element-236" />
    </div>;
}